<template lang="pug">
  div
    p.type-thin.top-space {{ gettext('Contact information') + ':'}}
    .grid.bordered-bottom.contact-information
      div.grid-children
        p.type {{ gettext('Phone') }}
        p {{ cv.phone }}
        p.type {{ gettext('Email') }}
        p {{ cv.email }}
        p.type {{ gettext('Skype') }}
        p {{ cv.skype }}
        p.type {{ gettext('Facebook') }}
        p {{ cv.facebook }}
</template>
<script>
import { gettext } from '@/services/TranslateHandler'
export default {
  name: 'ProfileContacts',
  props: {
    cv: {
      default: () => {
        return {}
      }
    }
  },
  methods: {
    gettext: gettext
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/cv/parts/profile/parts/contacts/index.vue